import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { films } from "@/mocks/films";

const hotTags = ["经典", "近作", "热播", "修复版", "悬疑", "都市"];

export default function SidebarNav() {
  const location = useLocation();

  return (
    <aside className="hidden w-60 shrink-0 lg:block">
      <div className="sticky top-24 flex flex-col gap-5">
        <nav className="rounded-lg border border-background-200 bg-background-50 p-3">
          <p className="mb-2 px-2 text-[11px] uppercase tracking-[0.2em] text-foreground-400">站内导航</p>
          <Link
            to="/"
            className={
              location.pathname === "/"
                ? "flex cursor-pointer items-center gap-2 rounded-md bg-primary-50 px-3 py-2 text-sm font-medium text-primary-800"
                : "flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            }
          >
            <i className="ri-home-5-line text-base" />
            首页
          </Link>
          <Link
            to="/news"
            className={
              location.pathname.startsWith("/news")
                ? "flex cursor-pointer items-center gap-2 rounded-md bg-primary-50 px-3 py-2 text-sm font-medium text-primary-800"
                : "flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            }
          >
            <i className="ri-newspaper-line text-base" />
            影视资讯
          </Link>
        </nav>

        <div className="rounded-lg border border-background-200 bg-background-50 p-3">
          <p className="mb-2 flex items-center justify-between px-2 text-[11px] uppercase tracking-[0.2em] text-foreground-400">
            影片分类
            <span className="text-foreground-300">{categories.length}</span>
          </p>
          {categories.map((category) => {
            const count = films.filter((film) => film.categories.includes(category.key)).length;
            const active = location.pathname === `/category/${category.key}`;
            return (
              <Link
                key={category.key}
                to={`/category/${category.key}`}
                className={
                  active
                    ? "flex cursor-pointer items-center justify-between rounded-md bg-primary-50 px-3 py-2 text-sm font-medium text-primary-800"
                    : "flex cursor-pointer items-center justify-between rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
                }
              >
                <span className="flex items-center gap-2">
                  <span
                    className={
                      active
                        ? "flex h-1.5 w-1.5 items-center justify-center rounded-full bg-accent-500"
                        : "flex h-1.5 w-1.5 items-center justify-center rounded-full bg-background-300"
                    }
                  />
                  {category.name}片
                </span>
                <span className="text-xs text-foreground-400">{count}</span>
              </Link>
            );
          })}
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-4">
          <p className="mb-3 text-[11px] uppercase tracking-[0.2em] text-foreground-400">热门标签</p>
          <div className="flex flex-wrap gap-1.5">
            {hotTags.map((tag) => (
              <Link
                key={tag}
                to={`/news?q=${encodeURIComponent(tag)}`}
                className="cursor-pointer whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-accent-200 bg-accent-50 p-4">
          <p className="flex items-center gap-2 text-xs font-medium text-accent-800">
            <i className="ri-alert-line" />
            内容说明
          </p>
          <p className="mt-2 text-xs leading-relaxed text-foreground-600">
            站内影片与资讯均为虚构演示资料，仅用于内容展示，不提供在线播放、下载或任何形式的影音服务。
          </p>
        </div>
      </div>
    </aside>
  );
}